import * as React from 'react';

export function GastroStandard() {
  return (
    <section className="gastro-standard">
      <style>{`
        .gastro-standard {
          padding: 72px 24px;
          background: #fff;
        }
        .gastro-standard-inner {
          max-width: 720px;
          margin: 0 auto;
        }
        .gastro-standard h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
        }
        .gastro-standard .subtitle {
          font-size: 18px;
          color: #666;
          margin: 0 0 32px;
        }
        .gastro-checklist {
          list-style: none;
          padding: 0;
          margin: 0 0 28px;
        }
        .gastro-checklist li {
          display: flex;
          align-items: center;
          gap: 14px;
          padding: 14px 18px;
          font-size: 16px;
          color: #333;
          font-weight: 500;
          border-radius: 10px;
          margin-bottom: 8px;
          background: #f0fdf0;
        }
        .gastro-checklist li i {
          color: #1EAA25;
          font-size: 18px;
          flex-shrink: 0;
        }
        .gastro-standard .closing {
          font-size: 16px;
          color: #555;
          font-style: italic;
          margin: 0;
        }
        @media (max-width: 640px) {
          .gastro-standard h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="gastro-standard-inner">
        <h2>Nuestro estándar gastronómico</h2>
        <p className="subtitle">Selección pensada para cocina profesional</p>
        <ul className="gastro-checklist">
          <li><i className="fa fa-check-circle" /> Calibre uniforme</li>
          <li><i className="fa fa-check-circle" /> Rotación rápida</li>
          <li><i className="fa fa-check-circle" /> Control visual y de frescura</li>
          <li><i className="fa fa-check-circle" /> Sin liquidación de descarte</li>
          <li><i className="fa fa-check-circle" /> Productos listos para trabajar</li>
        </ul>
        <p className="closing">No vendemos lo que no usaríamos en nuestra propia cocina.</p>
      </div>
    </section>
  );
}
